export default __webpack_public_path__ + "static/media/4.ac069bce.webp";